import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { Card } from "../components/ui/card";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "../components/ui/table";
import { Badge } from "../components/ui/badge";
import { Button } from "../components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../components/ui/dialog";
import { MessageCircle, Eye, RefreshCw } from "lucide-react";

const STATUS_COLOR = {
  sent: "#16a34a",
  logged: "#3b82f6",
  error: "#dc2626",
  skipped: "#6b7280",
};

const TIPO_LABEL = {
  boas_vindas: "Boas-vindas",
  ticket_aberto: "Ticket aberto",
  status_ticket: "Status ticket",
  ticket_resolvido: "Ticket resolvido + NPS",
  lembrete_vencimento: "Lembrete vencimento",
  briefing_diretor: "Briefing diretor",
  assinatura_pendente: "Assinatura pendente",
};

export default function WhatsappLog() {
  const [logs, setLogs] = useState([]);
  const [detail, setDetail] = useState(null);
  const [loading, setLoading] = useState(false);

  const load = async () => {
    setLoading(true);
    try {
      const { data } = await api.get("/whatsapp-log");
      setLogs(data);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => { load(); }, []);

  return (
    <div className="space-y-5">
      <div className="flex items-end justify-between">
        <div>
          <h1 className="text-3xl font-display font-bold" style={{ color: "#1B3A6B" }}>
            Log de WhatsApp
          </h1>
          <p className="text-sm text-muted-foreground mt-1">
            Auditoria das mensagens via Twilio (modo log enquanto TWILIO_ACCOUNT_SID não está configurada)
          </p>
        </div>
        <Button onClick={load} variant="outline" disabled={loading} data-testid="wa-log-refresh">
          <RefreshCw size={14} className={`mr-2 ${loading ? "animate-spin" : ""}`} /> Atualizar
        </Button>
      </div>

      <Card>
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Data</TableHead>
              <TableHead>Tipo</TableHead>
              <TableHead>Para</TableHead>
              <TableHead>Modo</TableHead>
              <TableHead>Status</TableHead>
              <TableHead className="text-right">Ver</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {logs.map((l) => (
              <TableRow key={l.id} data-testid={`wa-row-${l.id}`}>
                <TableCell className="text-xs whitespace-nowrap">
                  {new Date(l.criado_em).toLocaleString("pt-BR")}
                </TableCell>
                <TableCell className="text-xs">
                  <Badge variant="outline">{TIPO_LABEL[l.tipo] || l.tipo}</Badge>
                </TableCell>
                <TableCell className="text-xs font-mono">{l.para || "—"}</TableCell>
                <TableCell>
                  <Badge style={{ background: l.mode === "twilio" ? "#16a34a" : "#6b7280", color: "white" }}>
                    {l.mode === "twilio" ? "Twilio" : "Log"}
                  </Badge>
                </TableCell>
                <TableCell>
                  <Badge style={{ background: STATUS_COLOR[l.status] || "#6b7280", color: "white" }}>
                    {l.status}
                  </Badge>
                </TableCell>
                <TableCell className="text-right">
                  <Button size="sm" variant="outline" onClick={() => setDetail(l)} data-testid={`wa-view-${l.id}`}>
                    <Eye size={12} className="mr-1" /> Mensagem
                  </Button>
                </TableCell>
              </TableRow>
            ))}
            {logs.length === 0 && (
              <TableRow>
                <TableCell colSpan={6} className="text-center text-muted-foreground py-8">
                  <MessageCircle size={20} className="inline mr-2" /> Nenhuma mensagem registrada.
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </Card>

      <Dialog open={!!detail} onOpenChange={(o) => !o && setDetail(null)}>
        <DialogContent className="max-w-md">
          <DialogHeader>
            <DialogTitle>{TIPO_LABEL[detail?.tipo] || detail?.tipo}</DialogTitle>
          </DialogHeader>
          {detail && (
            <div className="space-y-3">
              <div className="text-xs grid grid-cols-2 gap-1">
                <div><strong>Para:</strong> {detail.para}</div>
                <div><strong>Modo:</strong> {detail.mode}</div>
                <div><strong>Status:</strong> {detail.status}</div>
              </div>
              <div className="bg-green-50 border border-green-200 rounded-lg p-4">
                <pre className="whitespace-pre-wrap text-sm font-sans">{detail.mensagem}</pre>
              </div>
            </div>
          )}
        </DialogContent>
      </Dialog>
    </div>
  );
}
